import { useMemo } from 'react';
import { eventMinutesLate } from '../helpers/lateness';

const useMinutesLate = (showLateness: boolean, eventTime?: string, expectedTime?: string): (number | undefined) => {
  return useMemo(() => {
    if (showLateness && eventTime && expectedTime) {
      return eventMinutesLate(eventTime, expectedTime);
    }
    return undefined;
  }, [showLateness, eventTime, expectedTime]);
};

export default useMinutesLate;
